import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useFieldController } from '../../../../helpers/formManager';
import Field from '../../shared/ui/Field';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const createFieldName =
  fieldPathBuilders.deskScheduleSetting.ignoreIntervalsPerDay;

const IgnoreIntervalsPerDay = ({
  deskIndex,
  entityKey,
  className,
  disabled,
}) => {
  const { field } = useFieldController({
    name: createFieldName(deskIndex, entityKey),
    defaultValue: false,
  });

  // Будет внедрено позже
  return null;

  // return (
  //   <Field.Memoized
  //     type={Field.types.checkbox}
  //     checked={field.value}
  //     onChange={field.onChange}
  //     rootCN={className}
  //     disabled={disabled}
  //   >
  //     Игнорировать{' '}
  //     <Tooltip
  //       getPopupContainer={(triggerNode) => triggerNode.parentNode}
  //       title="Снимает ограничение производительности для сотрудников"
  //     >
  //       <Icon type="info-circle" className={styles.icon} />
  //     </Tooltip>
  //   </Field.Memoized>
  // );
};

export default IgnoreIntervalsPerDay;
